import type { VoterListQuery } from '../../graphql/queries/voterList.generated';
import { VOTER_LIST_ERROR_FALLBACK, fetchVoterList, type VoterFetchImpl } from './voterApi';
import { useVoterRequest, type VoterRequestState } from './useVoterRequest';

export type VoterListItem = VoterListQuery['voterList']['items'][number];
export type VoterListData = VoterListQuery['voterList'];

export type UseVoterListOptions = {
  search: string;
  state: string;
  page: number;
  rowsPerPage: number;
  fetchImpl?: VoterFetchImpl;
  enabled?: boolean;
};

export const useVoterList = ({
  search,
  state,
  page,
  rowsPerPage,
  fetchImpl,
  enabled = true,
}: UseVoterListOptions): VoterRequestState<VoterListData> =>
  useVoterRequest(
    JSON.stringify([search, state, page, rowsPerPage]),
    signal =>
      fetchVoterList({
        ...(search.length > 0 ? { search } : {}),
        ...(state.length > 0 ? { state } : {}),
        first: rowsPerPage,
        offset: page * rowsPerPage,
        signal,
        fetchImpl,
      }),
    VOTER_LIST_ERROR_FALLBACK,
    fetchImpl,
    enabled,
  );
